import { DEFAULT_FOLDER_CREATION } from "../../components/document/WithApiFileLocationProvider";

export const getPathForFileLocationExplorer = (address: string): string => {
  const splitted = address.split("/").filter((p) => p.length);
  if (!splitted.length) return "";
  splitted.unshift(DEFAULT_FOLDER_CREATION);
  return splitted.join(">");
};
